/* eslint-disable */
import { makeAutoObservable } from 'mobx';
import { configure } from 'mobx';
import { app_data_t } from '../logic/types';

configure({ enforceActions: 'never' });

class MainStore {
    constructor() {
        makeAutoObservable(this);
    }

    data: app_data_t = {
        state: 'init',
        user: JSON.parse(localStorage.getItem('user') || '{}') || null,
        activeTab: '/',
    };
  
}

export let mainStore = new MainStore();
export let mainData = mainStore.data;
